import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const BoardIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 27 22"
    >
      <g transform="translate(1 1)">
        <g transform="translate(-371.097 -467.5)">
          <line
            x1="25"
            transform="translate(371.097 474.06)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <line
            x1="25"
            transform="translate(371.097 480.94)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M129.1,74.733V68.222a.8.8,0,0,1,.863-.722h23.274a.8.8,0,0,1,.863.722V86.778a.8.8,0,0,1-.861.722H129.96a.8.8,0,0,1-.863-.722V74.733Z"
            transform="translate(242 400)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <line
            y2="20"
            transform="translate(379.971 467.5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  </CircledIcon>
);
